const Schedule = "Schedule";
const Appointment = "Appointment";
const BookAppointment = "Book Appointment";
const AppointmentDetails = `${Appointment} Details`;
const GroupEvent = "Group event";
const GroupEventDetails = `${GroupEvent} Details`;

const ScheduleAnalyticsSources = {
  AppointmentDetailView: `${Schedule} ${AppointmentDetails}`,
  Card: `${Schedule} Event Card`,
  GroupEventDetailView: `${Schedule} ${GroupEventDetails}`,
  LiveEventView: "Home Live Event View",
  ScheduleScreen: `${Schedule} Preview`,
  WaitingRoom: "Waiting Room - mobile",
} as const;

enum ScheduleAnalyticsFieldName {
  AppointmentExternalId = "Appointment External Id",
  PatientExternalId = "Patient External Id",
  ResponseExternalId = "Response External Id",
  SupportExternalId = "Support External Id",
}

const ScheduleAnalyticsPageView = {
  AppointmentDetailView: AppointmentDetails,
  GroupEventDetailView: GroupEventDetails,
  ScheduleScreen: Schedule,
};

const EditEventAnalyticsEvent = {
  EditAppointmentPressed: "Edit appointment pressed",
  EditGroupEventPressed: "Edit group event pressed",
};

const WaitingRoomAnalyticsEvent = {
  AssessmentSubmission: "Waiting room survey submitted button clicked",
  AssessmentViewed: "Waiting room - mobile page view",
  SkipAndJoin: "Waiting Room Skip and Join Now button clicked",
};

// eslint-disable-next-line no-restricted-syntax -- this object is used as a collection of constants rather than as an object directly
const ScheduleAnalyticsEvent = {
  AppointmentCardJoinZoom: `${Appointment} card join zoom pressed`,
  AppointmentCardPressed: `${Appointment} card pressed`,
  AppointmentDetailsAddToCalendar: `${AppointmentDetails} add to calendar pressed`,
  AppointmentDetailsCancel: `${AppointmentDetails} cancel event pressed`,
  AppointmentDetailsCancelAll: `${AppointmentDetails} cancel all future events pressed`,
  AppointmentDetailsJoinZoom: `${AppointmentDetails} join zoom pressed`,
  AppointmentDetailsReschedule: `${AppointmentDetails} reschedule pressed`,
  AppointmentOpenedFromDeepLink: `${Appointment} Opened from Deep Link`,
  BookAppointmentOpenedFromDeepLink: `${BookAppointment} Opened from Deep Link`,
  EditAppointmentOpenedFromDeepLink: `Edit ${Appointment} Opened from Deep Link`,
  GroupClassEventOpenedFromDeepLink: `${GroupEvent} Opened from Deep Link`,
  GroupEventCardJoinZoom: `${GroupEvent} card join zoom pressed`,
  GroupEventCardPressed: `${GroupEvent} card pressed`,
  GroupEventDetailsAddToCalendar: `${GroupEventDetails} add to calendar pressed`,
  GroupEventDetailsDecline: `${GroupEventDetails} decline pressed`,
  GroupEventDetailsJoinZoom: `${GroupEventDetails} join zoom pressed`,
  GroupEventDetailsUnregisterFromGroup: `${GroupEventDetails} unregister from this group pressed`,
  GroupEventDetailsUnregisterPatientFromGroup: `${GroupEventDetails} unregister patient from this group pressed`,
  LiveEventJoinZoom: "Live event join zoom pressed",
} as const;

export {
  EditEventAnalyticsEvent,
  ScheduleAnalyticsEvent,
  ScheduleAnalyticsFieldName,
  ScheduleAnalyticsPageView,
  ScheduleAnalyticsSources,
  WaitingRoomAnalyticsEvent,
};
